import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnDefinition } from '@src/app/shared/interfaces/column-definition.interface';
import { DocumentAnalysisRow } from '@features/dashboard/document-analysis/document-analysis.model';

@Component({
  selector: 'app-document-analysis-table',
  templateUrl: './document-analysis-table.component.html',
  styleUrls: ['./document-analysis-table.component.scss'],
  standalone: false,
})
export class DocumentAnalysisTableComponent {
  @Input() rows: DocumentAnalysisRow[] = [];
  /** Primeira carga em andamento: a tabela mostra o esqueleto no lugar de "Nenhum item". */
  @Input() loading = false;

  @Output() analyze = new EventEmitter<string>();

  /**
   * O `app-table` resolve template nomeado por `colDef.field`. A coluna de ações é uma
   * coluna normal (`action`) em vez da `rowActions` embutida, porque a embutida renderiza
   * header vazio e o design exige o header `AÇÃO`.
   */
  readonly columnDefinitions: ColumnDefinition[] = [
    new ColumnDefinition({
      field: 'company',
      header: 'EMPRESA',
      sortable: false,
      style: { width: 'auto', 'min-width': '280px' },
    }),
    new ColumnDefinition({
      field: 'pendingDocuments',
      header: 'PENDENTES',
      sortable: false,
      style: { width: '140px' },
    }),
    new ColumnDefinition({
      field: 'approvedDocuments',
      header: 'APROVADOS',
      sortable: false,
      style: { width: '120px', 'text-align': 'right' },
    }),
    new ColumnDefinition({
      field: 'rejectedDocuments',
      header: 'REJEITADOS',
      sortable: false,
      style: { width: '120px', 'text-align': 'right' },
    }),
    new ColumnDefinition({
      field: 'totalDocuments',
      header: 'TOTAL',
      sortable: false,
      style: { width: '100px', 'text-align': 'right' },
    }),
    new ColumnDefinition({
      field: 'composition',
      header: 'COMPOSIÇÃO',
      sortable: false,
      style: { width: '260px' },
    }),
    new ColumnDefinition({
      field: 'action',
      header: 'AÇÃO',
      sortable: false,
      ignoreExport: true,
      style: { width: '150px', 'text-align': 'right' },
    }),
  ];
}
